import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon"];

  connect() {
    this.initTheme();
  }

  initTheme() {
    const savedTheme = localStorage.getItem("theme");
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)",
    ).matches;

    if (savedTheme === "dark" || (!savedTheme && prefersDark)) {
      this.enableDark();
    } else {
      this.disableDark();
    }
  }

  toggle() {
    if (document.documentElement.classList.contains("dark")) {
      this.disableDark();
    } else {
      this.enableDark();
    }
  }

  enableDark() {
    document.documentElement.classList.add("dark");
    localStorage.setItem("theme", "dark");
    this.updateIcon(true);
  }

  disableDark() {
    document.documentElement.classList.remove("dark");
    localStorage.setItem("theme", "light");
    this.updateIcon(false);
  }

  updateIcon(isDark) {
    if (!this.hasIconTarget) return;

    if (isDark) {
      // Dark mode - show sun icon
      this.iconTarget.innerHTML = `
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
      `;
    } else {
      // Light mode - show moon icon
      this.iconTarget.innerHTML = `
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
      `;
    }
  }
}
